import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { AddNewActivity } from '../newCard/addNewActivity';
import { SaveNewActivity } from '../newCard/saveNewActivity';
import { AddNewTask } from '../newCard/addNewTask';
import { SaveNewTask } from '../newCard/saveNewTask';
import { AddNewSubtask } from '../newCard/addNewSubtask';
import { SaveNewSubtask } from '../newCard/saveNewSubtask';
import { ChangeSubtaskStatus } from '../cardEdit/changeSubtaskStatus';
import { StartCardTitleEditing } from '../cardEdit/startCardTitleEditing';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class CreateSubtaskFromTrackingView extends Action<StorymapState> {
    public static ACTION_TYPE = 'CreateSubtaskFromTrackingView';
    public _activityId: string = null;
    public _taskId: string = null;

    public constructor(public releaseId: string, public statusKey: number) {
        super(CreateSubtaskFromTrackingView.ACTION_TYPE);
    }
}

const activityMiddleware = async (state: StorymapState, action: CreateSubtaskFromTrackingView): Promise<boolean> => {
    const activityTitle = 'Unordered user stories';
    const activity = state.activities.find((x) => x.title === activityTitle);
    action._activityId = activity?.id;

    if (!activity) {
        const addAction = new AddNewActivity(0);
        await dispatch(addAction);
        action._activityId = addAction._cardId;
        await dispatch(new SaveNewActivity(action._activityId, activityTitle));
    }

    return true;
};

const taskMiddleware = async (state: StorymapState, action: CreateSubtaskFromTrackingView): Promise<boolean> => {
    const task = state.tasks.find((x) => !x.title && x.activityId === action._activityId);
    action._taskId = task?.id;

    if (!task) {
        const addAction = new AddNewTask(action._activityId, 0);
        await dispatch(addAction);
        action._taskId = addAction._cardId;
        await dispatch(new SaveNewTask(action._taskId, ''));
    }

    return true;
};

const subtaskMiddleware = async (state: StorymapState, action: CreateSubtaskFromTrackingView): Promise<boolean> => {
    const addAction = new AddNewSubtask(action._taskId, action.releaseId, 0);
    await dispatch(addAction);
    const subtaskId = addAction._cardId;
    await dispatch(new SaveNewSubtask(subtaskId, ''));
    await dispatch(new ChangeSubtaskStatus(subtaskId, action.statusKey));
    await dispatch(new StartCardTitleEditing(subtaskId));

    return true;
};

const reducer = (): void => {
    // @ts-ignore
};

//@ts-ignore
registerMiddleware(CreateSubtaskFromTrackingView.ACTION_TYPE, activityMiddleware);

//@ts-ignore
registerMiddleware(CreateSubtaskFromTrackingView.ACTION_TYPE, taskMiddleware);

//@ts-ignore
registerMiddleware(CreateSubtaskFromTrackingView.ACTION_TYPE, subtaskMiddleware);

//@ts-ignore
registerReducer(CreateSubtaskFromTrackingView.ACTION_TYPE, reducer);
